module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/filterIcon@2x-eec06c6fe5cf0b827d9d2aeaa368f5bc.png";